<template>
  <section
    class="page-links-outr pb-25"
    v-if="
      relatedLinkData &&
      relatedLinkData.options &&
      relatedLinkData.options.length > 0
    "
  >
    <div class="container">
      <div class="ct-related-page-links">
        <div class="ct-related-page-links-header">
          <span class="span-h6 custom-font-1">{{
            relatedLinkData.heading
          }}</span>
        </div>
        <div class="ct-related-page-links-content">
          <ul class="mobile-scroller scroll-hover pb-0" ref="hRScroll">
            <li v-for="(option, index) in relatedLinkData.options" :key="index">
              <template v-if="$root.enable_piwik_reload">
                <a
                  class="cat-cls"
                  :title="option.title"
                  :href="
                    getRouteLink(option.link.post_name, option.link.post_type)
                  "
                  >{{ option.title }}</a
                >
              </template>
              <template v-else>
                <router-link
                  class="cat-cls"
                  :title="option.title"
                  :to="
                    getRouteLink(option.link.post_name, option.link.post_type)
                  "
                  >{{ option.title }}</router-link
                >
              </template>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
//import { dragscroll } from "vue-dragscroll";

export default {
  name: "RelatedLinks",
  props: ["relatedLinkData"],
  // directives: {
  //   dragscroll: dragscroll,
  // },
  mounted: function () {
    let target = this.$refs.hRScroll;
    if (target) {
      target.addEventListener("wheel", (event) => {
        let toLeft = event.deltaY < 0 && target.scrollLeft > 0;
        let toRight =
          event.deltaY > 0 &&
          target.scrollLeft < target.scrollWidth - target.clientWidth;
        if (toLeft || toRight) {
          event.preventDefault();
          target.scrollLeft += event.deltaY;
        }
      });
    }
  },
};
</script>
<style lang="less" scoped>
@import "~@/assets/less/base/variable";
.page-links-outr {
  @media (max-width: @sizes[small]) {
    padding-top: 20px;
  }
  .container {
    padding: 0;
    @media (min-width: 768px) {
      padding: 0 15px;
    }
  }
  .ct {
    &-related-page-links {
      //background: @lightdark;
      .border-radius(0);
      padding: 0 20px;
      margin: 0;
      display: block;
      @media (max-width: @sizes[small]) {
        //background-color: @dark-blue2;
      }
      @media (min-width: @sizes[medium]) {
        .display-flex();
        .flex-direction-column();
        .align-items(flex-start);
        .border-radius(10px);
        margin: 35px 0 25px;
        padding: 0;
      }
      &-header {
        background-color: #002844;
        width: 100%;
        padding: 8px 8px 8px 20px;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        display: flex;
        align-items: center;
        .span-h6 {
          font-weight: bold;
          font-size: 16px;
          line-height: 160%;
          color: @white;
          margin-bottom: 0px;
          white-space: break-spaces;
          @media (min-width: @sizes[medium]) {
            margin-bottom: 0;
            margin-right: 27px;
          }
        }
      }
      &-content {
        background-color: #264860;
        width: 100%;
        padding: 16px 16px 16px 20px;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        ul {
          overflow-x: auto !important;
          white-space: nowrap;
          display: flex;
          align-items: center;
          @media (min-width: @sizes[medium]) {
            overflow-x: hidden !important;
          }
          &:hover {
            overflow: auto !important;
          }
          li {
            margin-right: 40px;
            display: inline-block;
            &:hover {
              text-decoration: underline;
            }
            &:last-child {
              margin-right: 0;
            }
            a {
              font-size: 16px;
              line-height: 160%;
              color: @white;
              font-family: var(--default-regular);
            }
          }
        }
      }

      .router-link-exact-active {
        color: @white !important;
      }
    }
  }
}

.pb-0 {
  padding-bottom: 0 !important;
}
.scroll-hover:hover {
  &::-webkit-scrollbar {
    height: 6px;
  }
}

.mobile-scroller::-webkit-scrollbar {
  height: 6px !important;
}
.mobile-scroller::-webkit-scrollbar-thumb {
  background-color: #333 !important;
}
.mobile-scroller::-webkit-scrollbar-track {
  margin: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/custom-block/RelatedLinks.vue